import React, { Component } from 'react';
import AuthService from '../utils/AuthService';

var Auth = new AuthService();

class UserRoleSelect extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();

		this.state = {
			needsUpdate: false
		};

		this.selectChanage = this.selectChanage.bind(this);
		this.updateButtonClick = this.updateButtonClick.bind(this);
	}

	selectChanage(event) {
		this.setState({
			needsUpdate: true,
			roleID: event.target.value
		});
	}

	updateButtonClick() {
		var data = new FormData();

		data.append("user_id", this.props.userID);
		data.append("role_id", this.state.roleID);

		this.Auth.post('/pp-users/role/update', data)
			.then((result) => {
				console.log(result);
			});

		this.setState({
			needsUpdate: false
		});
	}

    render() {

		let role = this.props.role,
			adminSelected = '',
			internalSelected = '',
			salesSelected = '',
			dealerSelected = '',
			userSelected = '',
			needsUpdate = '';

		switch (role) {
			case 'Admin':
				adminSelected = 'selected';
				break;
			case 'Internal':
				internalSelected = 'selected';
				break;
			case 'Sales':
				salesSelected = 'selected';
				break;
			case 'Dealer':
				dealerSelected = 'selected';
				break;
			case 'User':
				userSelected = 'selected';
				break;
		}

		if (this.state.needsUpdate === true) {
			needsUpdate = 'pp-show';
		}

        return (
            <div className="pp-user-role-select">
				<select className="pp-select" onChange={this.selectChanage}>
					<option value="1" selected={adminSelected}>Admin</option>
					<option value="90" selected={internalSelected}>Internal</option>
					<option value="100" selected={salesSelected}>Sales</option>
					<option value="200" selected={dealerSelected}>Dealer</option>
					<option value="300" selected={userSelected}>User</option>
				</select>
				<button
					className={"pp-update " + needsUpdate}
					onMouseUp={this.updateButtonClick}
				>Update</button>
            </div>
        );
    }
}

export default UserRoleSelect;



// WEBPACK FOOTER //
// ./src/components/UserRoleSelect.js